import {
  Button,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  InputProps,
  Paper,
  Tooltip,
  Close as CloseIcon,
  AddCircle,
  ArrowRight2,
  CloseCircle,
  SearchNormal1,
  ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon,
} from "../../../common/utils/mui-imports";
import { PageRegistrationProperties } from "../../../core/reducers/pageRegistrationReducer.types";
import HPRCheckBox from "../../../components/common/HPRCheckBox/HPRCheckBox";
import HPRDatePicker from "../../../components/common/HPRDatePicker/HPRDatePicker";
import HPRTextBox from "../../../components/common/HPRTextBox/HPRTextBox";
import { EnumTextBoxType } from "../../../components/common/HPRTextBox/HPRTextBox.enum";
import { EnumDateType } from "../../../components/common/HPRDatePicker/HPRDatePicker.enum";
import { useEffect, useRef, useState } from "react";
import { openPopup } from "../../../components/Popups/Popup.reducer";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { useAppDispatch, useAppSelector } from "../../../core/hooks";
import {
  ScheduleInspectionDTO,
  ScheduleSiteInspectionDTO,
} from "../../../common/types/common.dto.types";
import {
  ScheduleInspectionPageParametersType,
  ScheduleInspectionPageType,
  CheckBoxParametersType,
} from "./ScheduleInspectionPage.types";
import { useLocation, useNavigate } from "react-router-dom";
import {
  scheduleInspectionConfirmation,
  getScheduleInspectionInitialData,
  saveScheduleInspection,
} from "./ScheduleInspectionPage.action";
import {
  IsPastDate,
  formatDateToString,
  getFormatedDateForBackend,
} from "../../../common/functions/common.functions";
import SimpleReactValidator from "simple-react-validator";
import { scheduleInspectionReducerActions } from "./ScheduleInspectionPage.reducer";
import { InspectionSetPageParametersType } from "../InspectionSetPage/InspectionSetPage.types";
import { UsePromptTypes } from "../../../core/hooks/use-prompt/use-prompt.types";
import { usePrompt } from "../../../core/hooks/use-prompt/use-prompt";
import noData from "../../../images/no_data.svg";
import TooltipScrollContainer from "../../../components/common/TooltipScrollContainer/TooltipScrollContainer";

// ==============================|| VIEWS - PAGES - SCHEDULE INSPECTION ||============================== //

//TODO - TPE ----> change msg, when exsit new changes

const initialState = {
  ScheduleInspection: {
    InspectionSetId: 0,
    InspectionSetName: "",
    AssessmentTypeId: 0,
    AssessmentTypeCode: "",
    Sites: [] as Array<ScheduleSiteInspectionDTO>,
    PlannedCompletionDate: null,
  },
  Validator: new SimpleReactValidator({
    messages: {
      default: "This field is required",
    },
    validators: {
      plannedCompletionDate: {
        message: "This field is requicccred",
        rule: (val, params) => {
          return true;
        },
      },
    },
  }),
  NavigateToViewInspectionPage: false,
} as ScheduleInspectionPageType;

const ScheduleInspectionPage = (props: PageRegistrationProperties) => {
  //-----standard list heigh ------
  const mainHeading = useRef(null);
  const searchBar = useRef(null);
  const textBox = useRef(null);

  //Set Hight
  const [locationSetHeight, setLocationSetHeight] = useState(0);

  // use for page navigation
  const navigate = useNavigate();

  // Create a ref to track whether data has already been fetched.
  const dataFetchedRef = useRef(false);

  // Initialize the dispatch function from the Redux store.
  // This allows you to dispatch actions to update the Redux state.
  const dispatch = useAppDispatch();

  // Select the relevant slice of state from the Redux store.
  const scheduleInspectionState = useAppSelector(
    (state) => state.scheduleInspectionReducer
  );

  // Local state for managing page-specific UI or form state.
  const [scheduleInspectionPageState, setScheduleInspectionPageState] =
    useState(initialState);

  // Search state
  const [searchTerm, setSearchTerm] = useState("");
  const [isMouseOver, setIsMouseOver] = useState(false);

  const location = useLocation();
  const parameter: ScheduleInspectionPageParametersType = location.state;

  // page unload validations
  const [isDirty, setIsDirty] = useState(false);
  const prompt = {
    Message: "Do you want to discard the changes?",
    When: isDirty,
    YesBtnClick() {
      resetStateAndNavigateToBack(undefined, {
        InspectionSetId: parameter.InspectionSetId,
      } as InspectionSetPageParametersType);
    },
  } as UsePromptTypes;
  usePrompt(prompt);

  //-----Page load-----
  useEffect(() => {
    const calculateHeight = () => {
      const mainHeadingHeight = mainHeading?.current?.offsetHeight || 0;
      const searchBarHeight = searchBar?.current?.offsetHeight || 0;
      const textBoxHeight = textBox?.current?.offsetHeight || 0;

      let locationSetheight =
        window.innerHeight -
        (mainHeadingHeight + searchBarHeight + textBoxHeight) -
        170;

      setLocationSetHeight(locationSetheight);
    };

    // Calculate initial height
    calculateHeight();

    // Resize handler
    function handleResize() {
      calculateHeight();
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /**
   *  get initial data when page load
   */
  useEffect(() => {
    if (dataFetchedRef.current) return;

    dataFetchedRef.current = true;

    // hide messages when page load
    scheduleInspectionPageState.Validator?.hideMessages();

    // get schedule inspection data
    dispatch(getScheduleInspectionInitialData(parameter?.InspectionSetId ?? 0));
  }, []);

  /**
   * Synchronizes the local state when reducer state changes
   */
  useEffect(() => {
    // Prevent update if data hasn't been fetched yet
    if (!dataFetchedRef.current) return;

    // Update local state with the latest data
    setScheduleInspectionPageState((prevState) => {
      return {
        ...prevState,
        ScheduleInspection: {
          ...prevState.ScheduleInspection,
          InspectionSetId:
            scheduleInspectionState.ScheduleInspection?.InspectionSetId,
          AssessmentTypeId:
            scheduleInspectionState.ScheduleInspection?.AssessmentTypeId,
          Sites: scheduleInspectionState.ScheduleInspection?.Sites,
          InspectionName:
            scheduleInspectionState.ScheduleInspection?.InspectionName,
          PlannedCompletionDate:
            scheduleInspectionState.ScheduleInspection?.PlannedCompletionDate,
        },
        FilteredSites: scheduleInspectionState.ScheduleInspection?.Sites,
      };
    });
  }, [scheduleInspectionState.ScheduleInspection]);

  /**
   * React effect that triggers navigation to the "viewInspection" page
   * when the `NavigateToViewInspectionPage` flag in the Redux state becomes true.
   */
  useEffect(() => {
    if (scheduleInspectionState.NavigateToViewInspectionPage) {
      resetStateAndNavigateToBack("viewInspection", {
        TemplateId: parameter.InspectionSetId,
        AssessmentType: parameter.AssessmentType,
        TemplateName:
          scheduleInspectionState.ScheduleInspection?.InspectionSetName ?? "",
      });
      return;
    }
  }, [scheduleInspectionState.NavigateToViewInspectionPage]);

  /**
   * Effect to check if the schedule inspection form has unsaved changes.
   * Sets `isDirty` to true if any site is selected or if planned completion date or inspection name has changed.
   */
  useEffect(() => {
    const { ScheduleInspection } =
      scheduleInspectionPageState ?? ({} as ScheduleInspectionPageType);

    const { ScheduleInspection: reducerStateScheduleInspection } =
      scheduleInspectionState ?? ({} as ScheduleInspectionPageType);

    const { Sites } = ScheduleInspection ?? ({} as ScheduleInspectionDTO);

    setIsDirty(
      Sites?.some((some) => some.IsSelected ?? false) ||
        reducerStateScheduleInspection?.PlannedCompletionDate !==
          ScheduleInspection?.PlannedCompletionDate ||
        reducerStateScheduleInspection?.InspectionName !==
          ScheduleInspection?.InspectionName
    );
  }, [scheduleInspectionPageState.ScheduleInspection]);

  /**
   * Handles mouse enter event on the search input area.
   */
  const handleMouseEnter = () => setIsMouseOver(true);

  /**
   * Handles mouse leave event from the search input area.
   */
  const handleMouseLeave = () => setIsMouseOver(false);

  /**
   * Manually triggers the location filtering logic (search).
   */
  const onSearchLocations = () => {
    const filteredLocations =
      scheduleInspectionPageState.ScheduleInspection?.Sites?.filter((site) =>
        site.SiteName.toLowerCase().includes(searchTerm.toLowerCase())
      );

    setScheduleInspectionPageState((prevState) => ({
      ...prevState,
      FilteredSites: filteredLocations,
    }));
  };

  /**
   * reset filtered location
   */
  const resetFilteredLocations = () => {
    setScheduleInspectionPageState((prevState) => ({
      ...prevState,
      FilteredSites: scheduleInspectionPageState?.ScheduleInspection?.Sites,
    }));
  };

  /**
   * Updates the current search term state.
   */
  const handleSearchChange = (value: string) => {
    setSearchTerm(value);

    if (!value) {
      resetFilteredLocations();
    }
  };

  /**
   * Handles key press event in the search input.
   */
  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearchLocations();
    }
  };

  /**
   * Clears the search input and resets the search term.
   */
  const handleClearSearch = () => {
    setSearchTerm("");
    resetFilteredLocations();
  };

  /**
   * Updates the selection state of sites in the schedule inspection page.
   * @param params
   */
  const updateSiteSelection = (params: CheckBoxParametersType) => {
    const { ScheduleInspection, FilteredSites } = scheduleInspectionPageState;

    // Update the main Sites list
    const updatedSites = ScheduleInspection?.Sites?.map((site) => ({
      ...site,
      IsSelected:
        params.type === "single" && site.SiteId === params.id
          ? params.isChecked
          : params.type === "all"
          ? params.isChecked
          : site.IsSelected,
    }));

    // Update the FilteredSites list
    const updatedfilteredSites = FilteredSites.map((site) => ({
      ...site,
      IsSelected:
        params.type === "single" && site.SiteId === params.id
          ? params.isChecked
          : params.type === "all"
          ? params.isChecked
          : site.IsSelected,
    }));

    // Set the updated state using functional setState to ensure latest state
    setScheduleInspectionPageState((prevState) => ({
      ...prevState,
      ScheduleInspection: {
        ...prevState.ScheduleInspection,
        Sites: updatedSites,
      },
      FilteredSites: updatedfilteredSites,
    }));
  };

  /**
   *Callback for toggling the checkbox of a single site.
   */
  const onCheckBoxChangeCallBack = (id: number, isChecked: boolean): void => {
    updateSiteSelection({ type: "single", id: id, isChecked: isChecked });
  };

  /**
   *Callback for toggling the "Select All" checkbox.
   */
  const onSelectAllCheckBoxChangeCallBack = (isChecked: boolean): void => {
    updateSiteSelection({ type: "all", isChecked: isChecked });
  };

  /**
   * Determines whether the "Select All" checkbox should be fully checked.
   */
  const isSelectAllCheckBoxChecked = (): boolean => {
    const { Sites } = scheduleInspectionPageState.ScheduleInspection;
    return Sites?.length > 0 && !Sites?.some((some) => !some.IsSelected);
  };

  /**
   * Determines whether the "Select All" checkbox should be in an indeterminate state.
   */
  const isSelectAllCheckBoxIndeterminateChecked = (): boolean => {
    const { Sites } = scheduleInspectionPageState.ScheduleInspection;
    return (
      Sites?.length > 0 &&
      Sites?.some((some) => !some.IsSelected) &&
      Sites?.some((some) => some.IsSelected)
    );
  };

  /**
   * the selected/total site count
   */
  const getSelectedSiteCount = () => {
    const { Sites } = scheduleInspectionPageState.ScheduleInspection;
    const total = Sites?.length ?? 0;
    const selected = Sites?.filter((site) => site.IsSelected)?.length ?? 0;

    return (
      <>
        (<span>{selected}/</span>
        <span>{total}</span>)
      </>
    );
  };

  /**
   * Callback function to handle the planned completion date change.
   */
  const onPlannedCompletionDateCallBack = (date: string) => {
    const plannedCompletionDate = getFormatedDateForBackend(date);
    setScheduleInspectionPageState((prevState) => ({
      ...prevState,
      ScheduleInspection: {
        ...prevState.ScheduleInspection,
        PlannedCompletionDate: plannedCompletionDate,
      },
    }));
  };

  /**
   * Callback function when inspection name textbox change.
   */
  const onTextBoxChangeCallBack = (value: string) => {
    setScheduleInspectionPageState((prevState) => ({
      ...prevState,
      ScheduleInspection: {
        ...prevState.ScheduleInspection,
        InspectionName: value ?? "",
      },
    }));
  };

  /**
   * Generates a formatted tooltip title string for an inspection name.
   */
  const getSystemGenerateInspectionName = (siteName: string): string => {
    const { InspectionName } =
      scheduleInspectionPageState.ScheduleInspection ??
      ({} as ScheduleInspectionDTO);

    return `${siteName} - ${InspectionName}`;
  };

  /**
   * Handles the schedule button click event.
   */
  const ScheduleButtonClick = () => {
    const { ScheduleInspection, Validator } =
      scheduleInspectionPageState ?? ({} as ScheduleInspectionPageType);

    const isValid = Validator?.allValid();
    if (!isValid) {
      Validator?.showMessages();
      setScheduleInspectionPageState({ ...scheduleInspectionPageState });
      return;
    }

    const { Sites } = ScheduleInspection ?? ({} as ScheduleInspectionDTO);

    const selectedSites = [
      ...Sites?.filter((filter) => filter.IsSelected ?? false)?.map((site) => {
        return {
          ...site,
          SiteInspectionName: getSystemGenerateInspectionName(
            site.SiteName
          )?.trim(),
        };
      }),
    ];

    if (selectedSites?.length === 0) {
      return;
    }

    const scheduleInspection = {
      ...ScheduleInspection,
      Sites: selectedSites,
    };

    dispatch(
      scheduleInspectionConfirmation(scheduleInspection, onConfirmationCallBack)
    );
  };

  /**
   *  Schedule Inspection Confirmation Popup
   *  call from saga after validate duplicate inspection name
   * @param scheduleInspection
   */
  const onConfirmationCallBack = (
    scheduleInspection: ScheduleInspectionDTO
  ) => {
    const { Sites } = scheduleInspection ?? ({} as ScheduleInspectionDTO);

    const exampleSiteInspectionName = Sites[0].SiteInspectionName;

    dispatch(
      openPopup({
        Open: true,
        BulkAssignmentCss: true,
        BodyText: `<div class="text-bold">Please review the details to schedule...</div><br/>
          <div class="d-flex mb-5">
            <label class="body2 gray-text width200">Inspection Name Format:</label>
            <label>
                <span class="body2 gray-text"><span><<</span>LOCATION NAME<span>>> -</span></span>
                <span class="body2">${
                  scheduleInspection.InspectionName ?? ""
                }</span>
                <span class="body2 semi-bold">(Eg. ${exampleSiteInspectionName})</span>
            </label>
          </div>
          <div class="mb-5">
            <label class="body2 gray-text width200">Planned Completion Date:</label>
            <label class="body2">${formatDateToString(
              scheduleInspection?.PlannedCompletionDate
            )}</label>
          </div>
          <div>
            <label class="body2 gray-text width200">Inspection Set Name:</label>
            <label class="body2">${
              scheduleInspectionState?.ScheduleInspection?.InspectionSetName
            }</label>
          </div>
          <br/><div>
          <span class="text-bold">Location(s): </span><span>(${
            Sites?.length
          })</span>
          </b><br/><br/>
          <div>${Sites?.map((site) => {
            return `<span class="custom-tooltip-trigger">
                      <span class="body2">${site.SiteName}</span>
                      <div class="custom-tooltip placement-top">${site.SiteInspectionName}</div>
                  </span>`;
          })?.join(`<span class="pr-5">,</span>`)}
          </div>`,
        HeaderText: "Confirmation",
        PopupType: EnumPopupType.InfoConfirmPopup,
        NoButtonText: "Confirm",
        OkButtonText: "Cancel",
        Size: "modal-lg",
        NoBtnClick() {
          dispatch(saveScheduleInspection(scheduleInspection));
          setIsDirty(false);
        },
      } as PopupProps)
    );
  };

  /**
   * Resets the schedule inspection state and navigates back to the inspection set page.
   */
  const resetStateAndNavigateToBack = (navigateTo: string, options?: any) => {
    setScheduleInspectionPageState(initialState);
    dispatch(
      scheduleInspectionReducerActions.setScheduleInspectionInitialState(
        initialState
      )
    );
    if (navigateTo) {
      navigate(`/${navigateTo}`, {
        state: options,
      });
    }
  };

  /**
   * default inspection name using the assessment type and planned completion date.
   */
  const promptDiscardUnsavedChanges = () => {
    const tempIsDirty = isDirty;
    setIsDirty(false);
    if (tempIsDirty) {
      dispatch(
        openPopup({
          Open: true,
          BodyText: "Do you want to discard the changes?",
          HeaderText: "Confirmation",
          PopupType: EnumPopupType.YesNoConfirmation,
          YesBtnClick() {
            resetStateAndNavigateToBack("inspectionSet", {
              InspectionSetId: parameter.InspectionSetId,
            } as InspectionSetPageParametersType);
          },
          NoBtnClick() {
            setIsDirty(tempIsDirty);
          },
        } as PopupProps)
      );
    } else {
      resetStateAndNavigateToBack("inspectionSet", {
        InspectionSetId: parameter.InspectionSetId,
      } as InspectionSetPageParametersType);
    }
  };

  /**
   * Generates a default inspection name based on the assessment type code and planned completion date.
   */
  const getDefaultInspectionNameFormat = (): string => {
    return `<<LOCATION NAME>> -`;
  };

  return (
    <>
      {/* Global Header with Status & Version */}

      {/* <Grid item lg={6} md={6} sm={12} xs={12} className="" ref={mainHeading}>
          <h1>{props.PageTitle}</h1>
        </Grid> */}

      {/* Global Header with Status & Version  End*/}

      <div className="content-section-card top-main-padding">
        {/* Global Sub Header with  Buttons*/}
        <div>
          <Grid
            container
            className="global-subhead-btn-wrap top-main-border-inner flex-wrap-wrap"
            ref={mainHeading}
          >
            <Grid item className="global-subhead-wrap mr-auto">
              <div className="flex--container">
                <div className="flex__item--inherit pr-10">
                  <h2>
                    <Button
                      aria-label="back"
                      className="sub-head-back-btn back"
                      onClick={promptDiscardUnsavedChanges}
                      title="Back to home page"
                    >
                      {/* <ArrowLeft2 size="24" variant="Outline" /> */}
                      <ArrowBackIosNewOutlinedIcon className="" />
                      <span className="body-bold secondary-color">Back</span>
                    </Button>
                  </h2>
                </div>
                <div className="global-header-wrap rem-trak-head-res d-flex">
                  <h1 className="page-title no-wrap">{props.PageTitle}</h1>
                  <span className="d-flex pl-10 pr-10 fx-align-center arrow-separator">
                    <ArrowRight2 size="20" color="#023047" />
                  </span>
                  <Tooltip
                    title={
                      scheduleInspectionState.ScheduleInspection
                        ?.InspectionSetName
                    }
                  >
                    <h1 className="tab-view-fnt-resize limit-1">
                      {
                        scheduleInspectionState.ScheduleInspection
                          ?.InspectionSetName
                      }
                    </h1>
                  </Tooltip>
                  <div className="standards-status ml-10 fx-middle">
                    <span className="status-color all">
                      {
                        scheduleInspectionState.ScheduleInspection
                          ?.AssessmentTypeCode
                      }
                    </span>
                  </div>
                </div>
              </div>
            </Grid>

            {/* Global Sub Header with  Buttons*/}

            <div
              // lg={6}
              // md={6}
              // sm={12}
              // xs={12}
              className="d-flex ml-auto"
            >
              <Button
                className="secondary-btn-small"
                size="small"
                variant="outlined"
                onClick={promptDiscardUnsavedChanges}
                startIcon={<CloseCircle variant="Outline" />}
              >
                Cancel
              </Button>

              <Button
                className="primary-btn-small"
                variant="outlined"
                disableElevation
                onClick={() => {
                  ScheduleButtonClick();
                }}
                startIcon={<AddCircle variant="Outline" />}
                size="small"
              >
                Schedule
              </Button>
            </div>
          </Grid>
        </div>

        <div className="content-inner-wrap pl-10 pr-10">
          {/* Location Options */}
          <fieldset style={{ paddingTop: "5px" }} className="mb-0">
            <legend>
              Location(s)<span className="red-text">*</span>
            </legend>
            <Grid container spacing={1} ref={searchBar}>
              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <div className="d-flex align-center">
                  {/* <FormControlLabel className="default-label"> */}
                  <HPRCheckBox
                    Id={"selectAll"}
                    Name={"selectAll"}
                    Label={"Select All"}
                    LabelClassName="no-wrap schedule-location-label"
                    checked={isSelectAllCheckBoxChecked()}
                    indeterminateChecked={isSelectAllCheckBoxIndeterminateChecked()}
                    onCheckBoxChange={(_, checked) =>
                      onSelectAllCheckBoxChangeCallBack(checked)
                    }
                    Disabled={
                      scheduleInspectionPageState.FilteredSites?.length === 0
                    }
                  ></HPRCheckBox>
                  <div
                    className="d-flex align-center"
                    style={{ lineHeight: 3 }}
                  >
                    {getSelectedSiteCount()}
                  </div>
                  {/* </FormControlLabel> */}
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <div className="sub-question-wrapper two-col">
                  <div className="search-bar--small">
                    <Paper
                      component="form"
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <InputBase
                        value={searchTerm ?? ""}
                        onChange={(event) => {
                          event.stopPropagation();
                          handleSearchChange(event.target?.value);
                        }}
                        //onKeyPress={handleSearchKeyPress}
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search by Location"
                        inputProps={{ "aria-label": "search" }}
                        onKeyDown={handleSearchKeyPress}
                      />
                      {isMouseOver && searchTerm && searchTerm.length > 0 && (
                        <Tooltip title="Clear" placement="top">
                          <IconButton
                            className="mr-0"
                            onClick={handleClearSearch}
                          >
                            <CloseIcon
                              style={{ color: "#219ebc", fontSize: "20px" }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}

                      <Tooltip title="Search" placement="top">
                        <IconButton
                          type="button"
                          sx={{ p: "10px" }}
                          aria-label="search"
                          className="m-0"
                          onClick={onSearchLocations}
                        >
                          <SearchNormal1
                            variant="Outline"
                            className="ico-secondary"
                            size={18}
                          />
                        </IconButton>
                      </Tooltip>
                    </Paper>
                  </div>
                </div>
              </Grid>
            </Grid>
            <TooltipScrollContainer
              className="d-flex width100-p"
              style={{ maxHeight: locationSetHeight, overflowY: "auto" }}
            >
              <TooltipScrollContainer className="sub-question-wrapper width100-p">
                <Grid container spacing={1}>
                  <>
                    {/* no data start */}
                    {scheduleInspectionPageState.FilteredSites?.length ===
                      0 && (
                      <div className="no-data width100-p flex--container">
                        <img className="" src={noData} style={{}}></img>
                        <div className="gray-text body2 flex__item--vcenter nodata-text">
                          No records found
                        </div>
                      </div>
                    )}
                    {/* no data end */}
                  </>
                  {scheduleInspectionPageState.FilteredSites?.map(
                    (site: ScheduleSiteInspectionDTO, index: number) => {
                      return (
                        <Grid
                          item
                          xs={6}
                          sm={4}
                          md={3}
                          lg={3}
                          xl={2}
                          key={`${site.SiteName}_${index}`}
                        >
                          <HPRCheckBox
                            Id={`${site.SiteName}_${index}`}
                            Name={`${site.SiteName}_${index}`}
                            Label={site.SiteName}
                            checked={site.IsSelected}
                            showLabelTooltip={true}
                            LabelClassName="no-wrap schedule-location-label"
                            onCheckBoxChange={(_, checked) =>
                              onCheckBoxChangeCallBack(site.SiteId, checked)
                            }
                          ></HPRCheckBox>
                        </Grid>
                      );
                    }
                  )}
                </Grid>
              </TooltipScrollContainer>
            </TooltipScrollContainer>
          </fieldset>
          <div className="flex--container mb-20 v-align validate-msg-wrapper">
            <div className="validate-msg flex__item srv-validation-message">
              {scheduleInspectionPageState.Validator.message(
                "filteredSites",
                scheduleInspectionPageState.ScheduleInspection?.Sites?.filter(
                  (filter) => filter.IsSelected ?? false
                ),
                "required"
              )}
            </div>
          </div>
          <FormGroup>
            <Grid container spacing={2} ref={textBox}>
              <Grid item xs={12} sm={4}>
                <div className="ant-date-outer">
                  <HPRDatePicker
                    ClassName="width-100p"
                    Id="plannedCompletionDate"
                    Name={"plannedCompletionDate"}
                    Label={"Planned Completion Date"}
                    Value={
                      scheduleInspectionPageState?.ScheduleInspection
                        ?.PlannedCompletionDate
                    }
                    Required
                    Type={EnumDateType.DateOnly}
                    onDateChange={(_, date) =>
                      onPlannedCompletionDateCallBack(date)
                    }
                    IsDisabledDate={IsPastDate}
                  ></HPRDatePicker>
                  <span className="date-validation">
                    {scheduleInspectionPageState.Validator.message(
                      "plannedCompletionDate",
                      scheduleInspectionPageState.ScheduleInspection
                        .PlannedCompletionDate,
                      "required"
                    )}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={8}>
                <div className="form-group inspection-name-format">
                  <HPRTextBox
                    Id="InspectionName"
                    Name="InspectionName"
                    Value={
                      scheduleInspectionPageState?.ScheduleInspection
                        ?.InspectionName ?? ""
                    }
                    Label={"Inspection Name Format"}
                    Type={EnumTextBoxType.Text}
                    onTextBoxChange={(_, value) =>
                      onTextBoxChangeCallBack(value)
                    }
                    ComponentProps={
                      {
                        startAdornment: (
                          <InputAdornment position="start">
                            {getDefaultInspectionNameFormat()}
                          </InputAdornment>
                        ),
                      } as Partial<InputProps>
                    }
                    TextLength={170}
                    ShowTextCounter
                    InputProps={{ maxLength: 170 }}
                    Required
                  />
                  <span className="date-validation">
                    {scheduleInspectionPageState.Validator.message(
                      "InspectionName",
                      scheduleInspectionPageState.ScheduleInspection
                        .InspectionName,
                      "required"
                    )}
                  </span>
                </div>
              </Grid>
            </Grid>
          </FormGroup>
        </div>
      </div>
    </>
  );
};

export default ScheduleInspectionPage;
function dispatch(arg0: { payload: PopupProps; type: "popup/openPopup" }) {
  throw new Error("Function not implemented.");
}

function setIsDirty(arg0: boolean) {
  throw new Error("Function not implemented.");
}
